import { Component, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  loginForm: FormGroup;
  error: string = '';
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', Validators.required]
    });
  }

  get isButtonDisabled(): boolean {
    return this.loading || this.loginForm.invalid;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
    if (loading) {
      this.loginForm.disable();
    } else {
      this.loginForm.enable();
    }
    // Forzar la detección de cambios para evitar problemas de timing
    this.cdr.detectChanges();
  }

  async onSubmit() {
    if (this.loginForm.valid) {
      this.setLoading(true);
      this.error = '';
      
      const { username, password } = this.loginForm.value;
      
      try {
        const success = await this.authService.login(username, password);
        
        if (success) {
          console.log('Login exitoso');
          // La redirección ya se maneja en el servicio de auth
        } else {
          this.error = 'Credenciales inválidas. Por favor, verifica tu usuario y contraseña.';
        }
      } catch (error) {
        console.error('Error en el proceso de login:', error);
        this.error = 'Error en el servidor. Por favor, intenta nuevamente.';
      } finally {
        this.setLoading(false);
      }
    } else {
      if (this.loginForm.get('username')?.errors?.['required']) {
        this.error = 'El usuario es requerido.';
      } else if (this.loginForm.get('username')?.errors?.['minlength']) {
        this.error = 'El usuario debe tener al menos 3 caracteres.';
      } else if (this.loginForm.get('password')?.errors?.['required']) {
        this.error = 'La contraseña es requerida.';
      } else {
        this.error = 'Por favor, completa todos los campos correctamente.';
      }
    }
  }
}